/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './card-section-simple';
import '../card/index';
import '../cta/card-cta-footer';
import '../card-group/card-group';
import '../card-group/card-group-item';
import '../content-section/content-section';
import '../content-section/content-section-heading';
